module.exports = __webpack_public_path__ + "img/recoleccion2.52f2b65f.png";